import Vue from 'vue'
import VueFacebookPixel from 'vue-analytics-facebook-pixel'

Vue.use(VueFacebookPixel)
Vue.analytics.fbq.init(process.env.VUE_APP_FB_ANALYTICS_PIXEL_ID, {}, { 'agent': process.env.VUE_APP_FB_PIXEL_AGENT })
